<script lang="ts">
	import type { ClassValue } from 'svelte/elements';
	import Icon from '$lib/components/icons/Icon.svelte';
	import PageLinkAdjacent from '$lib/components/pagination/PageLinkAdjacent.svelte';
	import PageLinkNumber from '$lib/components/pagination/PageLinkNumber.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		currentPage: number;
		totalPages: number;
		pageHref: (page: number) => string;
		isMultiPoi?: boolean;
		class?: ClassValue;
		onSelectPage?: (page: number) => void;
	}

	const {
		currentPage,
		totalPages,
		pageHref,
		isMultiPoi = false,
		class: classes,
		onSelectPage,
	}: Props = $props();
</script>

<div class={['flex flex-col justify-center items-center', classes]}>
	<div class="flex justify-center items-center mb-1">
		<span class={['text-sm', currentPage === totalPages ? 'visible' : 'invisible']}>
			- {m.pagination__end_of_results()} -
		</span>
	</div>
	<nav
		aria-label={m.pagination__aria_labels__nav()}
		class="flex flex-row justify-center items-center gap-1"
	>
		{#if isMultiPoi}
			<PageLinkAdjacent
				type="left"
				page={currentPage - 1}
				{onSelectPage}
				{pageHref}
				disabled={currentPage === 1}
			/>
			<PageLinkAdjacent
				type="right"
				page={currentPage + 1}
				{onSelectPage}
				{pageHref}
				disabled={currentPage === totalPages}
			/>
		{:else}
			{#if currentPage > 1}
				<PageLinkNumber
					icon="west"
					ariaLabel={m.pagination__aria_labels__prev()}
					page={currentPage - 1}
					{onSelectPage}
					{pageHref}
				/>
				<PageLinkNumber
					page={1}
					{onSelectPage}
					{pageHref}
					ariaLabel={m.pagination__aria_labels__first()}
				/>
			{/if}

			{#if currentPage > 3}
				<Icon icon="more-horiz" />
			{/if}

			{#if currentPage > 2}
				<PageLinkNumber page={currentPage - 1} {onSelectPage} {pageHref} />
			{/if}

			<PageLinkNumber page={currentPage} active disabled {pageHref} />

			{#if currentPage < totalPages - 1}
				<PageLinkNumber page={currentPage + 1} {onSelectPage} {pageHref} />
			{/if}

			{#if currentPage < totalPages - 2}
				<Icon icon="more-horiz" />
			{/if}

			{#if currentPage < totalPages}
				<PageLinkNumber
					page={totalPages}
					{onSelectPage}
					{pageHref}
					ariaLabel={m.pagination__aria_labels__last()}
				/>
				<PageLinkNumber
					icon="east"
					ariaLabel={m.pagination__aria_labels__next()}
					page={currentPage + 1}
					disabled={currentPage === totalPages}
					{onSelectPage}
					{pageHref}
				/>
			{/if}
		{/if}
	</nav>
</div>
